export default "__VITE_ASSET__6e4a76ad__"